import { useGetCompanySpecificIndustryList } from "@/api/services/global/master";
import { toNumber } from "@/utils/number";
import { useCallback } from "react";

type TOptionId = number | string | null | undefined;

const isKept = (id: TOptionId, keepId: TOptionId) => keepId !== null && keepId !== undefined && keepId !== "" && toNumber(id) === toNumber(keepId);

export const useSpecificSkillCompanySpecificIndustryOptions = () => {
  const { data, isLoading } = useGetCompanySpecificIndustryList();

  const getCompanySpecificIndustryOptions = useCallback(
    (keepId?: TOptionId) =>
      data
        .filter(
          (industry) =>
            isKept(industry.id, keepId) || industry.companySpecificBusinessClassifications.some((classification) => classification.isSpecificSkill),
        )
        .map((industry) => ({ label: industry.companySpecificIndustry, value: toNumber(industry.id), hidden: industry.isHidden })),
    [data],
  );

  const getCompanySpecificBusinessClassificationOptions = useCallback(
    (companySpecificIndustryId: TOptionId, keepId?: TOptionId) => {
      const industry = data.find((item) => toNumber(item.id) === toNumber(companySpecificIndustryId));
      if (!industry) return [];
      return industry.companySpecificBusinessClassifications
        .filter((classification) => classification.isSpecificSkill || isKept(classification.id, keepId))
        .map((classification) => ({
          label: classification.companySpecificBusinessClassificationName,
          value: classification.id,
          hidden: classification.isHidden,
        }));
    },
    [data],
  );

  return { isLoading, getCompanySpecificIndustryOptions, getCompanySpecificBusinessClassificationOptions };
};
